import { useState } from 'react';
import { submitUserFeedback } from '../api/feedback';
import { useLocale } from '../hooks/useLocale';

export default function ContactForm() {
  const { t: translations } = useLocale();
  const t = translations.contact;
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const data = new FormData(form);
    setStatus('sending');
    setErrorMessage('');

    try {
      await submitUserFeedback({
        name: data.get('name'),
        email: data.get('email'),
        message: data.get('message'),
      });
      setStatus('success');
      form.reset();
    } catch (error) {
      setStatus('error');
      setErrorMessage(error.message || t.errorGeneric);
    }
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <label>
        {t.name}
        <input
          type="text"
          name="name"
          required
          minLength={2}
          maxLength={120}
          autoComplete="name"
          placeholder={t.namePlaceholder}
          disabled={status === 'sending'}
        />
      </label>
      <label>
        {t.email}
        <input
          type="email"
          name="email"
          required
          maxLength={255}
          autoComplete="email"
          placeholder={t.emailPlaceholder}
          disabled={status === 'sending'}
        />
      </label>
      <label className="contact-form__full">
        {t.message}
        <textarea
          name="message"
          rows="4"
          required
          minLength={4}
          maxLength={8000}
          placeholder={t.messagePlaceholder}
          disabled={status === 'sending'}
        />
      </label>
      <button
        type="submit"
        className="btn btn-primary contact-form__submit"
        disabled={status === 'sending'}
      >
        {status === 'sending' ? t.sending : t.submit}
      </button>
      {status === 'success' ? (
        <p
          className="contact-form__status contact-form__status--success"
          role="status"
        >
          {t.success}
        </p>
      ) : null}
      {status === 'error' ? (
        <p
          className="contact-form__status contact-form__status--error"
          role="alert"
        >
          {errorMessage}
        </p>
      ) : null}
    </form>
  );
}
